import "./AddDriverDetailsModal.scss"
import React, { FC, useMemo, useState } from "react"
import { Button, FormControl, FormLabel, Typography } from "@mui/material"
import GenericModal from "../GenericAppModal/GenericModal.component"
import useFormValidation from "../../../hooks/useFormValidation"
import { useAppDispatch, useAppSelector } from "../../../redux/hooks"
import { RootState } from "../../../redux/store"
import { addDriverDetailsAsync } from "../../../redux/slices/driverSlice"
import { useTranslationLabel } from "../../../hooks/useTranslationLabel"
import AppInput from "../../AppInput/AppInput.component"
import { ModalTypes, showModal } from "../../../redux/slices/modalSlice"
import likeIcon from "../../../assets/images/like.png"
import { useValidationSchemas } from "../../../hooks/useIsValidationScehemes"
import { countryCodes } from "../../../config/countryCodes.const"
import "./AddDriverDetailsModal.scss"
import CountrySelect from "../../PhoneInput/CountrySelectPrefix"
import PhoneInput from "../../PhoneInput/PhoneInput.component"

type AddDriverDetailsProps = {
  open: boolean
  handleClose: () => void
}

const AddDriverDetails: FC<AddDriverDetailsProps> = ({ open, handleClose }) => {
  const dispatch = useAppDispatch()
  const modalData: any = useAppSelector((state: RootState) => state.modal.data)
  const [loading, setLoading] = useState(false)
  const { driverDetailsSchema } = useValidationSchemas()
  const { formData, errors, handleChange, validateForm } = useFormValidation(
    {
      firstName: "",
      lastName: "",
      phone: "",
    },
    driverDetailsSchema,
  )
  const {
    ADD_DRIVER,
    ADD_A_DRIVER,
    ADD_A_DRIVER_DETAILS_MODAL_DESCRIPTION,
    ERROR_MODAL_TITLE,
    ERROR_MODAL_DESCRIPTION,
    ADD_A_DRIVER_DETAILS_SUCCESS_MODAL_DESCRIPTION_1,
    ADD_A_DRIVER_DETAILS_SUCCESS_MODAL_DESCRIPTION_2,
    INPUT_COUNTRY,
    FIREST_NAME,
    LAST_NAME,
    PHONE_NUMBER,
  } = useTranslationLabel()

  const countryCodesForamt = useMemo(() => {
    return countryCodes.map((code) => {
      return {
        value: code,
        label: code,
      }
    })
  }, [])

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    setLoading(true)

    try {
      if (validateForm()) {
        const response = await dispatch(
          addDriverDetailsAsync({ ...formData, email: modalData.email }),
        ).unwrap()
        if (response) {
          dispatch(
            showModal({
              activeModal: ModalTypes.SIMPLE_MODAL,
              data: {
                title: ADD_A_DRIVER,
                description: ADD_A_DRIVER_DETAILS_SUCCESS_MODAL_DESCRIPTION_1,
                description2: ADD_A_DRIVER_DETAILS_SUCCESS_MODAL_DESCRIPTION_2,
                image: likeIcon,
              },
            }),
          )
        }
      }
    } catch (error) {
      dispatch(
        showModal({
          activeModal: ModalTypes.SIMPLE_MODAL,
          data: {
            title: ERROR_MODAL_TITLE,
            description: ERROR_MODAL_DESCRIPTION,
          },
        }),
      )
    }
    setLoading(false)
  }

  return (
    <GenericModal
      open={open}
      handleClose={handleClose}
      title={ADD_A_DRIVER}
      description={ADD_A_DRIVER_DETAILS_MODAL_DESCRIPTION}
      className="add-driver-details"
      loading={loading}
    >
      <form onSubmit={handleSubmit} className="form-container column">
        {Object.keys(formData).map((key: any) => {
          type FormDataKeys = "firstName" | "lastName" | "phone"
          const fieldKey = key as FormDataKeys
          if (key === "phone") {
            return (
              <PhoneInput
                label={PHONE_NUMBER}
                name={fieldKey}
                value={formData[fieldKey]}
                key={fieldKey}
                error={errors[fieldKey]}
                onChange={handleChange}
              />
            )
          }
          return (
            <AppInput
              label={key === "firstName" ? FIREST_NAME : LAST_NAME}
              name={fieldKey}
              value={formData[fieldKey]}
              key={fieldKey}
              error={errors[fieldKey]}
              onChange={handleChange}
            />
          )
        })}
        <Button
          type="submit"
          variant="contained"
          className="primary-btn"
          disabled={loading}
        >
          {ADD_DRIVER}
        </Button>
      </form>
    </GenericModal>
  )
}

export default AddDriverDetails
